var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EqsStepper',{attrs:{"value":0,"steps":[
        { title: 'test simple doc edition', item: {} },
        { title: 'test simple doc edition 2', item: {} }
    ],"eqs-type":['default', 'no-overflow'],"eqs-data-type":"default"}},[_c('GlobalTextEditor',{staticClass:"fill-height mx-auto",attrs:{"value":_vm.value},on:{"update:value":function($event){_vm.value=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }